import { render, staticRenderFns } from "./SenaWinners.vue?vue&type=template&id=18ad74fc&"
import script from "./SenaWinners.vue?vue&type=script&lang=js&"
export * from "./SenaWinners.vue?vue&type=script&lang=js&"
import style0 from "./SenaWinners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports